import { render, staticRenderFns } from "./card-bills.vue?vue&type=template&id=ed3c3b3c&scoped=true&"
import script from "./card-bills.vue?vue&type=script&lang=js&"
export * from "./card-bills.vue?vue&type=script&lang=js&"
import style0 from "./card-bills.vue?vue&type=style&index=0&id=ed3c3b3c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3c3b3c",
  null
  
)

export default component.exports